import { Component, EventEmitter, Output, ViewChild, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonModal } from '@ionic/angular';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-top-up-other-person-card-modal',
    templateUrl: './top-up-other-person-card-modal.component.html',
    styleUrls: ['top-up-other-person-card-modal.component.scss']
})
export class TopUpOtherPersonCardModalComponent extends BaseComponent implements OnInit, OnDestroy {
    @Output() cardAdded: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild(IonModal) removeTopUpModal: IonModal;

    cardForm: FormGroup;
    cardValidationLength: number;
    isFormSubmitted = false;

    constructor(
        @Inject('ENV') public env: Env,
        private formBuilder: FormBuilder
    ) {
        super();
    }

    ngOnInit(): void {
        this.cardValidationLength = this.env.PURCHASE_FLOW?.UTN_TRAVEL_CARD_LENGTH || 10;

        this.cardForm = this.formBuilder.group({
            cardNumber: ['', [Validators.required, Validators.pattern(`^[0-9]{${this.cardValidationLength}}$`)]]
        });
    }

    openModal(): void {
        this.isFormSubmitted = false;
        this.cardForm.reset();
        this.removeTopUpModal?.present();
    }

    closeModal(): void {
        this.removeTopUpModal.dismiss(null, 'cancel');
    }

    setCardNumber(): void {
        this.isFormSubmitted = true;

        const cardNumber = this.cardForm.get('cardNumber')?.value;

        if (this.cardForm.invalid || !cardNumber) {
            return;
        }

        this.cardAdded.emit(Number(cardNumber));
        this.closeModal();
    }

    shouldShowError(controlName: string, errorType: string): boolean {
        const control = this.cardForm.get(controlName);
        return control?.hasError(errorType) && (control.touched || this.isFormSubmitted);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
